import httpService from "app/services/httpService";
import config from "../../../src/config.json";

const apiUrl = config.apiUrl;

const getUserGroup = async (queryString) => {
  try {
    const url = `${apiUrl}/usergroups${queryString ? `?${queryString}` : ""}`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const getUserGroupforEdit = async () => {
  try {
    const url = `${apiUrl}/usergroups`;
    const { data } = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const addUserGroup = async (req) => {
  try {
    const url = `${apiUrl}/usergroups`;
    const { data } = await httpService.post(url, req);
    return data;
  } catch (error) {
    throw error;
  }
};

const updateUserGroup = async (id, req) => {
  try {
    const url = `${apiUrl}/usergroups/${id}`;
    const { data } = await httpService.put(url, req);
    return data;
  } catch (error) {
    throw error;
  }
};

const deleteUserGroup = async (id) => {
  try {
    const url = `${apiUrl}/usergroups/${id}`;
    const { data } = await httpService.delete(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const getTagMarkup = async () => {
  try {
    const url = `${apiUrl}/usergroups/tagmarkup`;
    const { data } = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const getCommissionMarkup = async () => {
  try {
    const url = `${apiUrl}/usergroups/commissionmarkup`;
    const { data } = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const getUsergroupById = async (id) => {
  try {
    const url = `${apiUrl}/usergroups/${id ? id : ""}`;
    const { data } = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

export {
  getUserGroup,
  getUserGroupforEdit,
  addUserGroup,
  updateUserGroup,
  deleteUserGroup,
  getTagMarkup,
  getUsergroupById,
  getCommissionMarkup,
};
